export const strings = {
  NAME: "Kanban",
  DESCRIPTION:
    "Organize data in a way that helps you track where things stand.",
  NEW_CARD_BUTTON_DEFAULT_COPY: "New card",
} as const;
